import { render, staticRenderFns } from "./SlideWrap.vue?vue&type=template&id=65e721bc&scoped=true&"
import script from "./SlideWrap.vue?vue&type=script&lang=js&"
export * from "./SlideWrap.vue?vue&type=script&lang=js&"
import style0 from "./SlideWrap.vue?vue&type=style&index=0&id=65e721bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e721bc",
  null
  
)

export default component.exports